// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import Modal from 'react-responsive-modal'
import styled, { type StyledComponent } from 'styled-components'
import AutoSizeTextArea from '../../AutoSizeTextArea'
import PrimaryButton from '../PrimaryButton'
import postJson from '../../../services/postJson'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 100%;
`
const Header: StyledComponent<Object, any, any> = styled.div`
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 10px;
`
const SubHeader: StyledComponent<Object, any, any> = styled.div`
  font-size: 12px;
  padding-bottom: 10px;
  color: #666;
`
const StyledTextArea: StyledComponent<Object, any, any> = styled(AutoSizeTextArea)`
  border: solid 1px #ccc;
  padding: 8px;
  width: 100%;
  resize: none;
`
const MatcherError: StyledComponent<Object, any, any> = styled.div`
  color: #800;
  padding: 5px 0;
`
const MatcherButton: StyledComponent<Object, any, any> = styled(PrimaryButton)`
  height: 30px;
  line-height: 30px;
  margin: 10px 0;
`

type Props = {|
  className: string,
  isOpen: boolean,
  maxElementsCount: number,
  requestPath: string,
  placeholder: string,
  subtitle: string,
  title: string,
  matchElements: (Array<Object>, Array<string>) => Array<Object>,
  onClose: () => void,
  onSelect: (Array<Object>) => void,
  onParseFromInput: (string) => Array<string>
|}

type State = {|
  elementsToMatch: Array<string>,
  firstSearch: boolean,
  error: ?string,
  textareaValue: string,
  isLoading: boolean
|}

const t = {
  nothing_to_search: 'Не указан ни один элемент для поиска',
  too_many_elements: 'Превышено ограничение на количество элементов. Максимум: ',
  error_happened: 'Произошла ошибка при поиске',
  not_found: 'Не удалось ничего найти',
  ready: 'Готово'
}

export default class Matcher extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      elementsToMatch: [],
      firstSearch: true,
      error: null,
      textareaValue: '',
      isLoading: false
    }
  }

  render() {
    return (
      <Modal
        classNames={{ modal: this.props.className }}
        styles={{
          modal: {
            width: '100%',
            backgroundColor: 'white',
            height: '300px',
            zIndex: '130'
          }
        }}
        open={this.props.isOpen}
        onClose={() => this.popupClose()}
      >
        <Wrapper>
          <Header>
            <span>{this.props.title}</span>
          </Header>
          <SubHeader>
            <span>{this.props.subtitle}</span>
          </SubHeader>
          <StyledTextArea
            className="t-VkGroupsIds"
            minRows={5}
            maxRows={5}
            placeholder={this.props.placeholder}
            onChange={(e) => this.onChange(e.target.value)}
            value={this.state.textareaValue}
          />
          {this.state.error && <MatcherError>{this.state.error}</MatcherError>}
          <MatcherButton
            disabled={this.state.isLoading}
            onClick={(e) => {
              e.preventDefault()
              this.search()
            }}
          >
            {t.ready}
          </MatcherButton>
        </Wrapper>
      </Modal>
    )
  }

  onChange(input: string) {
    this.setState({
      error: null,
      elementsToMatch: this.props.onParseFromInput(input),
      textareaValue: input
    })
  }

  search() {
    const { requestPath, maxElementsCount } = this.props
    const { elementsToMatch, firstSearch } = this.state
    if (elementsToMatch.length === 0) return this.setState({ error: t.nothing_to_search })
    if (elementsToMatch.length > maxElementsCount)
      return this.setState({ error: t.too_many_elements + maxElementsCount })

    this.setState({ isLoading: true })
    if (firstSearch) {
      this.setState({ firstSearch: false })
      setTimeout(() => {
        this.search()
      }, 1000)
    }
    postJson(requestPath, { search: elementsToMatch })
      .done((response) => {
        const matchedElements = this.props.matchElements(response.result, elementsToMatch)
        if (response.error || _.isEmpty(matchedElements)) {
          this.setState({ error: t.not_found })
        } else {
          this.resetAndSignal(matchedElements)
        }
      })
      .fail(() => this.setState({ error: t.error_happened }))
      .always(() => this.setState({ isLoading: false }))
  }

  resetAndSignal(elements: Array<Object>) {
    if (elements.length) {
      this.props.onSelect(elements)
      this.popupClose()
    }
  }

  popupClose() {
    this.setState({
      elementsToMatch: [],
      error: null,
      textareaValue: '',
      isLoading: false
    })
    this.props.onClose()
  }
}
